import React from "react"
import PropTypes from "prop-types"
import moment from "moment"
import FiltersWithStore from "../Filters/FiltersWithStore"
import ResultCount from "../ResultCount"
import SearchResultsVirtualized from "./SearchResultsVirtualized"
import Loading from "../Loading"
import CSVButton from "@swipesense/csv-button"
import "./SearchResults.scss"
import { filterBoxesResults } from "./filterAssets"

class SearchResults extends React.Component {
  constructor(props) {
    super(props)

    this.state = { displayFilterDropdown: false }
  }

  toggleFilterDropdown = () => {
    this.setState({ displayFilterDropdown: !this.state.displayFilterDropdown })
  }

  hideFilterDropdown = () => {
    this.setState({ displayFilterDropdown: false })
  }

  CSVHeaders = [
    "Asset ID",
    "Serial Number",
    "Device Type",
    "Model",
    "Manufacturer",
    "Department Owners",
    "Last Location",
    "Last Unit",
    "Last Detected",
  ]

  mapCSVData = searchResult => ({
    "Asset ID": searchResult.item.assetId,
    "Serial Number": searchResult.item.serialNumber,
    "Device Type": searchResult.item.name,
    Model: searchResult.item.modelName,
    Manufacturer: searchResult.item.manufacturer,
    "Department Owners": searchResult.item.owners
      .map(owner => owner.name)
      .join("|"),
    "Last Location":
      searchResult.item.location && searchResult.item.location.name,
    "Last Unit":
      searchResult.item.location && searchResult.item.location.unit.name,
    "Last Detected": searchResult.item.lastSeenAt
      ? moment(searchResult.item.lastSeenAt).format()
      : "asset tagged but not yet detected", // Display in local time.
  })

  render() {
    const {
      selectedFiltersLength,
      filteredSearchedAssets,
    } = filterBoxesResults(
      this.props.searchedAssets,
      this.props.staticFilters,
      this.props.assetFilters.selectedAssets
    )

    return (
      <div className="search-results-container">
        <div className="SearchResults">
          {this.props.deviceType === "desktop" ? null : (
            <ResultCount
              resultCount={filteredSearchedAssets.length}
              deviceType={this.props.deviceType}
              toggleFilterDropdown={this.toggleFilterDropdown}
              selectedFiltersCount={selectedFiltersLength}
              loading={this.props.loading}
              updateTime={this.props.formattedUpdateTime}
            />
          )}
          <div className="filters-container">
            <FiltersWithStore
              searchedAssets={this.props.searchedAssets}
              displayDropdown={this.state.displayFilterDropdown}
              hideDropdown={this.hideFilterDropdown}
              deviceType={this.props.deviceType}
              loading={this.props.loading}
              staticFilters={this.props.staticFilters}
              assetFilters={this.props.assetFilters}
            />
          </div>
          {this.props.loading ? (
            <Loading />
          ) : (
            <div className="filtered-results">
              <CSVButton
                filename="assets.csv"
                headers={this.CSVHeaders}
                data={filteredSearchedAssets}
                mapData={this.mapCSVData}
              />
              {this.props.deviceType === "desktop" ? (
                <ResultCount
                  resultCount={filteredSearchedAssets.length}
                  deviceType={this.props.deviceType}
                  toggleFilterDropdown={this.toggleFilterDropdown}
                  loading={this.props.loading}
                  updateTime={this.props.formattedUpdateTime}
                />
              ) : null}
              <hr />
              <div className="results">
                <SearchResultsVirtualized
                  results={filteredSearchedAssets}
                  deviceType={this.props.deviceType}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

SearchResults.propTypes = {
  searchedAssets: PropTypes.array,
  staticFilters: PropTypes.shape({
    onlyRented: PropTypes.bool,
    onlyStationary: PropTypes.bool,
  }),
  loading: PropTypes.bool,
  assetFilters: PropTypes.shape({
    selectedAssets: PropTypes.array,
  }),
  deviceType: PropTypes.string.isRequired,
  formattedUpdateTime: PropTypes.string,
}

SearchResults.defaultProps = {
  staticFilters: { onlyRended: false, onlyStationary: false },
  assetFilters: { selectedAssets: [] },
  searchedAssets: [],
  deviceType: "desktop",
}

export default SearchResults
